enum AuthUserMethods {
  SET_USER_OBJECT_DATA = 'SET_USER_OBJECT_DATA',
}

export default AuthUserMethods;
